const attrs = {
  name: "",
};

const actions = {
  open: async ({ dispatch, commit }, id) => {
    dispatch("clearStore", null, { root: true });
    const payload = { type: "spaces", id };
    try {
      await dispatch("fetchResource", payload, { root: true });
      commit("activate", id);
      dispatch("users/findAll", { query: { space_id: id } }, { root: true });
    } catch (err) {
      commit("activate", null);
    }
  },
};

export default {
  generic: {
    attrs,
  },
  actions,
};
